import React, { Component } from 'react';

class ConfigurationsGeneral extends Component {
    render() {
        return (
            <div>
                Configuraciones generales
            </div>
        );
    }
}

ConfigurationsGeneral.propTypes = {

};

export default ConfigurationsGeneral;